export const getConversations = state => state.conversations.all.data;
export const getConversation = state => state.conversations.conversation;
export const getDevMode = state => state.conversations.devMode;
export const isFetchingConversations = state => state.conversations.loading.all;
export const isFetchingConversation = state => state.conversations.loading.conversation;
export const isUpdateConversation = state => state.conversations.loading.updateConversation;